export default function InvolvedHero() {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-brand-50 via-white to-accent-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          {/* Left: text */}
          <div className="max-w-2xl">
            <div className="inline-block px-4 py-1.5 bg-accent-50 border border-accent-100 rounded-full mb-6">
              <span className="text-xs font-semibold text-accent-600 tracking-widest font-heading">
                MAKE A DIFFERENCE
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6 font-heading">
              Get Involved
            </h1>
            <p className="text-lg text-gray-500 leading-relaxed font-body">
              You don't have to be a scientist or a doctor to make a difference for CSCF families. Every share, every connection, every voice raised in awareness matters. Here's how you can help.
            </p>
          </div>

          {/* Right: vertical logo */}
          <div className="flex-shrink-0 flex items-center justify-center lg:justify-end">
            <img
              src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/c5ebe5a9-2b4a-4fd5-b434-a49ce4d88d88_CSCF_Logo_ON_WHITE_VERTICAL.png?v=ea902609bd6b1c2d9db6b96c36df757d"
              alt="CSCF Support"
              className="h-64 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
